import { createSlice } from "@reduxjs/toolkit";

import {
  addApiCases,
  addApiCasesTable,
  createDynamicThunk,
} from "../../../../service/requestHandler";

export const vmCurrentList = createDynamicThunk(
  "vmCurrentList",
  "/report/api/v1/vm/currentVulnerabilities",
  ["pageNumber", "itemsPerPage"]
);

export const vmOpenList = createDynamicThunk(
  "vmOpenList",
  "/report/api/v1/vm/currentVulnerabilities",
  ["pageNumber", "itemsPerPage"]
);

export const vmPlannedList = createDynamicThunk(
  "vmPlannedList",
  "/report/api/v1/vm/currentVulnerabilities",
  ["pageNumber", "itemsPerPage"]
);

export const vmExceptionList = createDynamicThunk(
  "vmExceptionList",
  "/report/api/v1/vm/currentVulnerabilities",
  ["pageNumber", "itemsPerPage"]
);

export const vmCurrentListCount = createDynamicThunk(
  "vmCurrentListCount",
  "/api/v1/tenableNessusRest/getVulnerabilityListCount"
);

export const vmTargetDueDate = createDynamicThunk(
  "vmTargetDueDate",
  "/api/v1/tenableNessusRest/getTargetDateDueDrillDownList",
  ["year", "month", "pageNumber", "itemsPerPage"]
);

export const vmTargetDueDateCount = createDynamicThunk(
  "vmTargetDueDateCount",
  "/api/v1/tenableNessusRest/getTargetDateDueDrillDownListCount",
  ["year", "month"]
);

export const vmCurrentListDrilldown = createDynamicThunk(
  "vmCurrentListDrilldown",
  "/report/api/v1/vm/currentVulnerabilities",
  ["pageNumber", "itemsPerPage"]
);

export const vmCurrentListCountDrilldown = createDynamicThunk(
  "vmCurrentListCountDrilldown",
  "/api/v1/tenableNessusRest/getVulnerabilityListCount"
);

export const vmCurrentListMissed = createDynamicThunk(
  "vmCurrentListMissed",
  "/report/api/v1/vm/VulnerabilityListForTargetDate",
  ["pageNumber", "itemsPerPage"]
);

export const vmCurrentListCountMissed = createDynamicThunk(
  "vmCurrentListCountMissed",
  "/api/v1/tenableNessusRest/getTargetDateListCount"
);

export const vmFixedList = createDynamicThunk(
  "vmFixedList",
  "/report/api/v1/vm/fixedVulnerabilities",
  ["pageNumber", "itemsPerPage"]
);

export const vmFixedListCount = createDynamicThunk(
  "vmFixedListCount",
  "/api/v1/tenableNessusRest/getFixedVulnerabilityListCount"
);

export const vmExcludedList = createDynamicThunk(
  "vmExcludedList",
  "/report/api/v1/vm/excludedVulnerabilities",
  ["pageNumber", "itemsPerPage"]
);

export const cveIdApi = createDynamicThunk(
  "cveIdApi",
  "/api/v1/trs/getEpssScore",
  ["props"]
);

export const vmTRSServerity = createDynamicThunk(
  "vmTRSServerity",
  "/report/api/v1/vm/vulnerabilitiesByTRSSeverity"
);

export const vmRiskCount = createDynamicThunk(
  "vmRiskCount",
  "/report/api/v1/vm/getTopFiveMostAtRiskAssetsCount"
);

export const vmTop5RiskAssets = createDynamicThunk(
  "vmTop5RiskAssets",
  "/report/api/v1/vm/getTopFiveMostAtRiskAssets",
  ["pageNumber", "itemsPerPage"]
);

export const vmRiskAssets = createDynamicThunk(
  "vmRiskAssets",
  "/report/api/v1/vm/getTopFiveMostAtRiskAssets",
  ["pageNo", "pageLimit"]
);

export const ApplicationCountAPI = createDynamicThunk(
  "ApplicationCountAPI",
  "/report/api/v1/vm/countAppCodes"
);

export const OpenVmApplicationApi = createDynamicThunk(
  "OpenVmApplicationApi",
  "/report/api/v1/vm/getTotalFindingsCount"
);

export const allRiskAppApi = createDynamicThunk(
  "allRiskAppApi",
  "/report/api/v1/vm/getTopFiveMostAtRiskApplications",
  ["pageNo", "pageLimit"]
);

export const getAPPTrsSeverityApi = createDynamicThunk(
  "getAPPTrsSeverityApi",
  "/report/api/v1/vm/getApplicationByTRSSeverity"
);

export const allRiskAppCountApi = createDynamicThunk(
  "allRiskAppCountApi",
  "/api/v1/tenableNessusRest/getTopFiveMostAtRiskApplicationCount"
);

export const ClosedVmApplicationApi = createDynamicThunk(
  "ClosedVmApplicationApi",
  "/report/api/v1/vm/getClosedVulnerabilitiesFindingsCount"
);

export const getTop5VulnerabilityCVEIDDetails = createDynamicThunk(
  "getTop5VulnerabilityCVEIDDetails",
  "/report/api/v1/vm/getTop5VulnerabilityCVEIDDetails"
);

export const getTop5VulnerabilityFamilyDetails = createDynamicThunk(
  "getTop5VulnerabilityFamilyDetails",
  "/report/api/v1/vm/getTop5VulnerabilityFamilyDetails"
);

export const ActionPlanbyAppAPI = createDynamicThunk(
  "ActionPlanbyAppAPI",
  "report/api/v1/vm/getStatusBySeverity"
);

export const vulDistribution = createDynamicThunk(
  "vulDistribution",
  "/api/v1/tenableNessusRest/findingsDistribution"
);

export const vulActionPlan = createDynamicThunk(
  "vulActionPlan",
  "/report/api/v1/vm/getStatusBySeverity"
);

export const openVulnerabilityAPI = createDynamicThunk(
  "openVulnerabilityAPI",
  "/report/api/v1/vm/getOpenFindingsCount"
);

export const top5RiskAppApi = createDynamicThunk(
  "top5RiskAppApi",
  "/report/api/v1/vm/getTopFiveMostAtRiskApplications",
  ["pageNumber", "itemsPerPage"]
);

export const treeChartApiCall = createDynamicThunk(
  "treeChartApiCall",
  "/report/api/v1/vm/getTreemapForCVEIdsDetails"
);

export const getBusinessDepartmentAPI = createDynamicThunk(
  "getBusinessDepartmentAPI",
  "/api/v1/tenableNessusRest/getBusinessDivision"
);

export const getBusinessDivisionAPI = createDynamicThunk(
  "getBusinessDivisionAPI",
  "/api/v1/tenableNessusRest/getBusinessDepartmentByDivision"
);

export const getTopVulnerability = createDynamicThunk(
  "getTopVulnerability",
  "/api/v1/tenableNessusRest/list/topVulnerability"
);

export const getCisoDetails = createDynamicThunk(
  "getCisoDetails",
  "/api/v1/tenableNessusRest/listByCiso/"
);

export const getVMdetailsfilterAPI = createDynamicThunk(
  "getVMdetailsfilterAPI",
  "/cmdb/api/v1/dropDownFields/VulnerabilityManagement/getListByType",
  [],
  "GET"
);

export const getVMAppAPI = createDynamicThunk(
  "getVMAppAPI",
  "/api/v1/tenableNessusRest/getApplicationByDivision"
);

export const getCISOaccount = createDynamicThunk(
  "getCISOaccount",
  "/api/v1/CSPForAws/accountIds"
);

export const getTargetDateListCount = createDynamicThunk(
  "getTargetDateListCount",
  "/api/v1/tenableNessusRest/getTargetDateListCount"
);

export const getListForTargetDate = createDynamicThunk(
  "getListForTargetDate",
  "/api/v1/tenableNessusRest/getListForTargetDate/",
  ["pageNumber", "itemsPerPage"]
);

export const getTargetDateDueDrillDownList = createDynamicThunk(
  "getTargetDateDueDrillDownList",
  "/report/api/v1/vm/getVulnerabilityManagementForTargetDateDueList",
  ["year", "month", "pageNumber", "itemsPerPage"]
);

export const getTargetDateDueDrillDownListCount = createDynamicThunk(
  "getTargetDateDueDrillDownListCount",
  "/api/v1/tenableNessusRest/getTargetDateDueDrillDownListCount/",
  ["year", "month"]
);

export const getTargetMissedItems = createDynamicThunk(
  "getTargetMissedItems",
  "/report/api/v1/vm/getTargetDates"
);

export const getVulnmanageTrendAPI = createDynamicThunk(
  "getVulnmanageTrendAPI",
  "/report/api/v1/vm/open/count"
);

export const getCloseVulnDistributionAPI = createDynamicThunk(
  "getCloseVulnDistributionAPI",
  "/report/api/v1/vm/getClosedFindingsCount"
);

export const getCvidCheck = createDynamicThunk(
  "getCvidCheck",
  "/report/api/v1/vm/checkingCveIds"
);

export const assetDistribution = createDynamicThunk(
  "assetDistribution",
  "/report/api/v1/vm/AssetsByTRSSeverity"
);

export const ExportCSV = createDynamicThunk(
  "ExportCSV",
  "/report/api/v1/vm/exportVulnerabilityManagementListAsCSV",
  [],
  "POST",
  {
    responseType: "blob",
    acceptHeader: "application/octet-stream"
  }
);

export const ExportClosedCSV = createDynamicThunk(
  "ExportClosedCSV",
  "/report/api/v1/vm/exportClosedVulnerabilityManagementListAsCSV",
  [],
  "POST",
  {
    responseType: "blob",
    acceptHeader: "application/octet-stream"
  }
);

export const ExportExcludedCSV = createDynamicThunk(
  "ExportExcludedCSV",
  "/report/api/v1/vm/exportExcludedVulnerabilityManagementListAsCSV",
  [],
  "POST",
  {
    responseType: "blob",
    acceptHeader: "application/octet-stream"
  }
);

export const VMCVSSSeverity = createDynamicThunk(
  "VMCVSSSeverity",
  "/report/api/v1/vm/list/categorizeVulnerability"
);

export const getSecurityDetails = createDynamicThunk(
  "getSecurityDetails",
  "/report/api/v1/licenceUsers/members",
  [],
  "GET"
);

export const VulnerabilityByAppAPI = createDynamicThunk(
  "VulnerabilityByAppAPI",
  "/report/api/v1/vm/getOpenCountByCriticalityFiltered"
);

export const VulTargetDateDuAPI = createDynamicThunk(
  "VulTargetDateDuAPI",
  "/report/api/v1/vm/getSixMonthTargetDate"
);

export const GetLatestExclusionStatus = createDynamicThunk(
  "GetLatestExclusionStatus",
  "/tenable/api/v1/vulnerabilityExclusion/getLatestExclusionStatus",
  [],
  "GET"
);

export const initialState = {
  vmCurrentListData: [],
  vmCurrentListLoading: false,
  vmOpenListData: [],
  vmOpenListDataLoading: false,
  vmPlannedListData: [],
  vmPlannedListDataLoading: false,
  vmExceptionListData: [],
  vmExceptionListDataLoading: false,
  vmCurrentListCountData: [],
  vmCurrentListCountLoading: false,
  vmTargetDueDateData: [],
  vmTargetDueDateLoading: false,
  vmTargetDueDateCountData: [],
  vmTargetDueDateCountLoading: false,
  vmCurrentListDrilldownData: [],
  vmCurrentListDrilldownLoading: false,
  vmCurrentListCountDrilldownData: [],
  vmCurrentListCountDrilldownLoading: false,
  vmCurrentListMissedData: [],
  vmCurrentListMissedLoading: false,
  vmCurrentListCountMissedData: [],
  vmCurrentListCountMissedLoading: false,
  vmFixedListData: [],
  vmFixedListDataLoading: false,
  vmFixedListCountData: [],
  vmFixedListCountLoading: false,
  vmExcludedListData: [],
  vmExcludedListDataLoading: false,
  cveIdApiData: [],
  cveIdApiLoading: false,
  vmTRSServerityData: [],
  vmTRSServerityLoading: false,
  vmRiskCountData: [],
  vmRiskCountLoading: false,
  vmTop5RiskAssetsData: [],
  vmTop5RiskAssetsLoading: false,
  vmRiskAssetsData: [],
  vmRiskAssetsLoading: false,
  ApplicationCountAPIData: [],
  ApplicationCountAPILoading: false,
  OpenVmApplicationApiData: [],
  OpenVmApplicationApiLoading: false,
  allRiskAppApiData: [],
  allRiskAppApiLoading: false,
  getAPPTrsSeverityApiData: [],
  getAPPTrsSeverityApiLoading: false,
  allRiskAppCountApiData: [],
  allRiskAppCountApiLoading: false,
  ClosedVmApplicationApiData: [],
  ClosedVmApplicationApiLoading: false,
  getTop5VulnerabilityCVEIDDetailsData: [],
  getTop5VulnerabilityCVEIDDetailsLoading: false,
  getTop5VulnerabilityFamilyDetailsData: [],
  getTop5VulnerabilityFamilyDetailsLoading: false,
  ActionPlanbyAppAPIData: [],
  ActionPlanbyAppAPILoading: false,
  vulDistributionData: [],
  vulDistributionLoading: false,
  vulActionPlanData: [],
  vulActionPlanLoading: false,
  openVulnerabilityAPIData: [],
  openVulnerabilityAPILoading: false,
  top5RiskAppApiData: [],
  top5RiskAppApiLoading: false,
  treeChartApiCallData: [],
  treeChartApiCallDataLoading: false,
  getBusinessDepartmentAPIData: [],
  getBusinessDepartmentAPILoading: false,
  getBusinessDivisionAPIData: [],
  getBusinessDivisionAPILoading: false,
  getTopVulnerabilityData: [],
  getTopVulnerabilityLoading: false,
  getCisoDetailsData: [],
  getCisoDetailsLoading: false,
  getVMdetailsfilterAPIData: [],
  getVMdetailsfilterAPILoading: false,
  getVMAppAPIData: [],
  getVMAppAPILoading: false,
  getCISOaccountData: [],
  getCISOaccountLoading: false,
  getTargetDateListCountData: [],
  getTargetDateListCountLoading: false,
  getListForTargetDateData: [],
  getListForTargetDateLoading: false,
  getTargetDateDueDrillDownListData: [],
  getTargetDateDueDrillDownListLoading: false,
  getTargetDateDueDrillDownListCountData: [],
  getTargetDateDueDrillDownListCountLoading: false,
  getTargetMissedItemsData: [],
  getTargetMissedItemsLoading: false,
  getVulnmanageTrendAPIData: [],
  getVulnmanageTrendAPILoading: false,
  getCloseVulnDistributionAPIData: [],
  getCloseVulnDistributionAPILoading: false,
  getCvidCheckData: [],
  getCvidCheckLoading: false,
  assetDistributionData: [],
  assetDistributionLoading: false,
  ExportCSVData: [],
  ExportCSVLoading: false,
  VMCVSSSeverityData: [],
  VMCVSSSeverityLoading: false,
  getSecurityDetailsData: [],
  getSecurityDetailsLoading: false,
  VulnerabilityByAppAPIData: [],
  VulnerabilityByAppAPILoading: false,
  VulTargetDateDuAPIData: [],
  VulTargetDateDuAPILoading: false,
  exclusionApplied: true,
  exclusionStatusData: null,
  exclusionStatusLoading: false,
};

export const vulnerabilitiesSlice = createSlice({
  name: "vulnerabilitiesSlice",
  initialState,
  reducers: {
    resetvulnerabilitiesSlice: () => initialState,
    resetVulnerabilityData: () => initialState,
    setDisabledCategories: (state, action) => {
      state.disabledCategories = action.payload;
    },
  },
  extraReducers: (builder) => {
    addApiCases(builder, vmCurrentList, "vmCurrentListData");
    addApiCases(builder, vmOpenList, "vmOpenListData");
    addApiCases(builder, vmPlannedList, "vmPlannedListData");
    addApiCases(builder, vmExceptionList, "vmExceptionListData");
    addApiCases(builder, vmCurrentListDrilldown, "vmCurrentListDrilldownData");
    addApiCases(builder, vmCurrentListMissed, "vmCurrentListMissedData");
    addApiCasesTable(
      builder,
      vmTargetDueDate,
      "vmTargetDueDateData",
      "vmTargetDueDateCountData"
    );

    addApiCases(builder, vmFixedList, "vmFixedListData");
    addApiCases(builder, vmExcludedList, "vmExcludedListData");
    addApiCases(builder, cveIdApi, "cveIdApiData");
    addApiCases(builder, vmTRSServerity, "vmTRSServerityData");
    addApiCases(builder, vmRiskCount, "vmRiskCountData");
    addApiCases(builder, vmTop5RiskAssets, "vmTop5RiskAssetsData");
    addApiCases(builder, vmRiskAssets, "vmRiskAssetsData");
    addApiCases(builder, ApplicationCountAPI, "ApplicationCountAPIData");
    addApiCases(builder, OpenVmApplicationApi, "OpenVmApplicationApiData");
    addApiCases(builder, allRiskAppApi, "allRiskAppApiData");
    addApiCases(builder, getAPPTrsSeverityApi, "getAPPTrsSeverityApiData");
    addApiCases(builder, allRiskAppCountApi, "allRiskAppCountApiData");
    addApiCases(builder, ClosedVmApplicationApi, "ClosedVmApplicationApiData");
    addApiCases(
      builder,
      getTop5VulnerabilityCVEIDDetails,
      "getTop5VulnerabilityCVEIDDetailsData"
    );
    addApiCases(
      builder,
      getTop5VulnerabilityFamilyDetails,
      "getTop5VulnerabilityFamilyDetailsData"
    );
    addApiCases(builder, ActionPlanbyAppAPI, "ActionPlanbyAppAPIData");
    addApiCases(builder, vulDistribution, "vulDistributionData");
    addApiCases(builder, vulActionPlan, "vulActionPlanData");
    addApiCases(builder, openVulnerabilityAPI, "openVulnerabilityAPIData");
    addApiCases(builder, top5RiskAppApi, "top5RiskAppApiData");
    addApiCases(builder, treeChartApiCall, "treeChartApiCallData");
    addApiCases(
      builder,
      getBusinessDepartmentAPI,
      "getBusinessDepartmentAPIData"
    );
    addApiCases(builder, getBusinessDivisionAPI, "getBusinessDivisionAPIData");
    addApiCases(builder, getTopVulnerability, "getTopVulnerabilityData");
    addApiCases(builder, getCisoDetails, "getCisoDetailsData");
    addApiCases(builder, getVMdetailsfilterAPI, "getVMdetailsfilterAPIData");
    addApiCases(builder, getVMAppAPI, "getVMAppAPIData");
    addApiCases(builder, getCISOaccount, "getCISOaccountData");
    addApiCases(builder, getTargetDateListCount, "getTargetDateListCountData");
    addApiCases(builder, getListForTargetDate, "getListForTargetDateData");
    addApiCases(
      builder,
      getTargetDateDueDrillDownList,
      "getTargetDateDueDrillDownListData"
    );
    addApiCases(builder, getTargetMissedItems, "getTargetMissedItemsData");
    addApiCases(builder, getVulnmanageTrendAPI, "getVulnmanageTrendAPIData");
    addApiCases(
      builder,
      getCloseVulnDistributionAPI,
      "getCloseVulnDistributionAPIData"
    );
    addApiCases(builder, getCvidCheck, "getCvidCheckData");
    addApiCases(builder, assetDistribution, "assetDistributionData");
    addApiCases(builder, ExportCSV, "ExportCSVData");
    addApiCases(builder, VMCVSSSeverity, "VMCVSSSeverityData");
    addApiCases(builder, getSecurityDetails, "getSecurityDetailsData");
    addApiCases(builder, VulnerabilityByAppAPI, "VulnerabilityByAppAPIData");
    addApiCases(builder, VulTargetDateDuAPI, "VulTargetDateDuAPIData");
    addApiCases(builder, GetLatestExclusionStatus, "exclusionStatusData");
  },
});

export const {
  resetvulnerabilitiesSlice,
  resetVulnerabilityData,
  setDisabledCategories,
} = vulnerabilitiesSlice.actions;
export default vulnerabilitiesSlice.reducer;
